module.exports = __webpack_public_path__ + "static/media/edit.6b989662.svg";